//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SketchOffset.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/Section.js";
let d=[[[0,"CapType",1,0],[0,"ConvertToReference",1,0],[0,"CreateConstraint",1,0],[0,"CreateDimension",1,0],[0,"Degree",1,0],[1,"Distance",0,"Expression",0],[0,"IsSymmetric",1,0],[0,"NumberOfCopies",1,0],[0,"Tolerance",1,0]],[[[],"CreateSection",{R_:{section:"Section"}},0,0],[["section"],"RemoveSection",{},1,0],[["object_in_chain"],"ReverseOffsetDirectionOfChain",{},1,0],[[],"ReverseOffsetDirection",{},0,0],[["object1","object2","help_pt"],"BreakChain",{},3,0],[["object1","object2","help_pt"],"MergeChains",{},3,0],[["object_in_chain","inx","is_start_end","constraint"],"SetEndConstraint",{},4,0],[["num_geom"],"GetOutputCurvesOfOffset",{R_:{geom:"NXObject[]"}},0,0],[["num_sections"],"GetSections",{R_:{sections:"Section[]"}},0,0],[[],"UpdateLoopsAndCopies",{},0,0],[[],"EvaluateOffset",{},0,0],[[],"UpdateSolverDistance",{},0,0],[[],"UpdateSymmetry",{},0,0]],[]];
SPLM.SketchOffsetBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchOffsetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;